module.exports = __webpack_public_path__ + "static/media/peds-clock@3x.2b0732b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peds-clock@3x.png
// module id = 1734
// module chunks = 0